import { openBlock as l, createElementBlock as a, createElementVNode as e } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 9 13"
}, o = /* @__PURE__ */ e("path", {
  fill: "currentColor",
  d: "M5.696 3.063c.706 0 1.281-.575 1.281-1.281C6.977 1.075 6.402.5 5.696.5c-.707 0-1.282.575-1.282 1.282 0 .706.575 1.281 1.282 1.281m3.06 3.967L7.158 3.693a.58.58 0 0 0-.482-.304H5.023a.38.38 0 0 0-.274.116l-.011.007-1.165.996A.97.97 0 0 0 3.29 5l-.405 2.227a.37.37 0 0 0 .317.437l.14.019-.432 1.48a.4.4 0 0 0-.117-.059l-1.276-.373a.387.387 0 0 0-.477.261l-.663 2.27a.385.385 0 0 0 .26.476l.983.287a.515.515 0 1 0 .86-.48l.574-1.964.564-1.93a.4.4 0 0 0 .224-.279l.384-1.842a.67.67 0 0 1 .208-.331l.205-.157V7.49q-.006.012-.01.025l-1.254 3.926a.614.614 0 0 0 .427.785l.084.022a.674.674 0 0 0 .806-.44l1.172-3.667.415 1.017c.102.249.21.684.24.95l.198 1.873a.565.565 0 0 0 .71.5l.084-.02a.72.72 0 0 0 .53-.77l-.295-2.284a4.5 4.5 0 0 0-.279-1.014L7.07 7.48l-.019-.035V5.812l.856 1.73a.353.353 0 0 0 .513.141l.186-.12a.426.426 0 0 0 .15-.533m-6.344 4.968a.305.305 0 0 1-.376.206.304.304 0 0 1-.206-.376.31.31 0 0 1 .376-.206.3.3 0 0 1 .206.376"
}, null, -1), n = [
  o
];
function c(r, s) {
  return l(), a("svg", t, [...n]);
}
const d = { render: c };
export {
  d as default,
  c as render
};
